import { DynamicContentSchemaStore } from './dynamic-content.store';
import { BaseQuery } from '../base/base.query';

export class DynamicContentSchemaQuery extends BaseQuery {
  constructor(store: DynamicContentSchemaStore) {
        super(store);
    }
}
